module.exports = require("@angular/animations");